/* Memorial · UX 01: nombre accesible para los banners enlazados del carrusel */
(function () {
  function nombrar() {
    /* Íconos de la franja de beneficios: carga inmediata (eran diferidos y se veían como un cuadro vacío) */
    document.querySelectorAll('.m-icon-box img[loading="lazy"]').forEach(function (i) { i.loading = 'eager'; });
    document.querySelectorAll('a.m-hidden-link').forEach(function (a) {
      if (a.getAttribute('aria-label')) return;
      var m = a.closest('.m-slide__media'), img = m && m.querySelector('img');
      var t = img && img.getAttribute('alt');
      if (t && !/^slider image/i.test(t)) a.setAttribute('aria-label', t);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', nombrar); else nombrar();
})();

/* Memorial · Medición (UX 02): eventos de comportamiento para Google Tag Manager / GA4.
   Solo envía datos de interacción; nunca nombres ni teléfonos. */
(function () {
  'use strict';
  function ev(nombre, datos) {
    window.dataLayer = window.dataLayer || [];
    var o = { event: nombre };
    for (var k in datos) if (Object.prototype.hasOwnProperty.call(datos, k)) o[k] = datos[k];
    window.dataLayer.push(o);
  }
  function corto(s, n) { return (s || '').toString().replace(/\s+/g, ' ').trim().slice(0, n || 100); }

  function iniciar() {
    var plantilla = document.documentElement.getAttribute('data-template') || '';

    /* Página no encontrada */
    if (plantilla === '404') ev('mm_error_404', { ruta: corto(location.pathname, 100), origen: corto(document.referrer, 100) });

    /* Clics de contacto: teléfono, correo y redes */
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var h = a.getAttribute('href') || '', canal = '';
      if (/^tel:/i.test(h)) canal = 'telefono';
      else if (/^mailto:/i.test(h)) canal = 'correo';
      else if (/instagram\.com/i.test(h)) canal = 'instagram';
      else if (/facebook\.com|fb\.me/i.test(h)) canal = 'facebook';
      else if (/tiktok\.com/i.test(h)) canal = 'tiktok';
      else if (/youtube\.com|youtu\.be/i.test(h)) canal = 'youtube';
      else if (/google\.[a-z.]+\/maps|maps\.app\.goo\.gl|goo\.gl\/maps/i.test(h)) canal = 'mapa';
      if (canal) ev('mm_clic_contacto', { canal: canal, origen: plantilla });
    }, true);

    /* Personalización del arreglo (ficha de producto) */
    var CAMPOS = { 'properties[Base]': 'base', 'properties[Horario]': 'horario', 'properties[Fecha]': 'fecha', 'properties[Dedicatoria]': 'tarjeta' };
    var ultimo = {};
    /* Solo cuenta lo que elige el cliente: la página preselecciona fecha, horario y tarjeta al cargar
       (cambios automáticos); se aceptan cambios reales o los provocados por un toque/tecla reciente del cliente. */
    var ultimaAccion = 0;
    function marcarAccion(e) { if (e.isTrusted) ultimaAccion = Date.now(); }
    ['pointerdown', 'mousedown', 'touchstart', 'keydown'].forEach(function (n) { document.addEventListener(n, marcarAccion, true); });
    document.addEventListener('change', function (e) {
      if (!e.isTrusted && Date.now() - ultimaAccion > 1500) return;
      var t = e.target, campo = t && CAMPOS[t.name];
      if (campo) {
        var valor = corto(t.value, 100);
        if (valor && ultimo[campo] !== valor) { ultimo[campo] = valor; ev('mm_personaliza', { campo: campo, valor: valor }); }
      } else if (t && t.id === 'de-parte-de' && t.value.trim() && !ultimo.envia) {
        ultimo.envia = true; ev('mm_personaliza', { campo: 'envia', valor: 'completado' }); // no se envía el nombre
      }
    }, true);

    /* Intento de compra bloqueado por datos faltantes: qué campo frena la venta */
    document.addEventListener('submit', function (e) {
      var f = e.target;
      var btn = document.getElementById('add-to-cart-btn');
      if (!f || !btn || !(btn.form === f || f.contains(btn) || (f.closest && f.closest('.m-product-form--wrapper')))) return;
      setTimeout(function () {
        var aviso = document.getElementById('atc-hint');
        if (aviso && aviso.classList.contains('is-visible')) ev('mm_compra_bloqueada', { motivo: corto(aviso.textContent, 100) });
      }, 0);
    }, true);

    /* Formulario de WhatsApp: abierto / enviado / cerrado sin enviar */
    var modal = document.getElementById('wl-modal');
    if (modal && window.MutationObserver) {
      var abierto = false, marca = 0;
      new MutationObserver(function () {
        var visible = !modal.hidden;
        if (visible && !abierto) {
          abierto = true; marca = (window.dataLayer || []).length;
          ev('whatsapp_popup', { accion: 'abierto', origen: plantilla });
        } else if (!visible && abierto) {
          abierto = false;
          var dl = window.dataLayer || [], enviado = false;
          for (var i = marca; i < dl.length; i++) if (dl[i] && dl[i].event === 'whatsapp_lead') { enviado = true; break; }
          ev('whatsapp_popup', { accion: enviado ? 'enviado' : 'cerrado', origen: plantilla });
        }
      }).observe(modal, { attributes: true, attributeFilter: ['hidden'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
